import { useStyletron } from "baseui";
import { Check } from "baseui/icon";
import { ModalButton} from "baseui/modal"
import { useSnackbar } from "baseui/snackbar";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IAutomationObject } from "../../automationObjects";
import { useMoveObjectMutation } from "../../services/objects";
import { GetObjectUrl } from "../../utils/navigationService";
import ObjectsSelectView, { onParentChangedArgs } from "../ObjectSelector/ObjectsSelectView";
import { FormattedMessage, useIntl } from 'react-intl';
import { ModalAutoSize } from "../../components/ModalAutoSize";


type MoveAppDialogProps = {
    isOpen: boolean,
    setIsOpen: any,
    appToMove: IAutomationObject,
    currentParent: IAutomationObject,
    onFilter: (item: IAutomationObject) => boolean,
}
const MoveAppDialog = ({ isOpen, setIsOpen, appToMove, currentParent, onFilter }: MoveAppDialogProps) => {
    const { enqueue } = useSnackbar();
    const navigate = useNavigate();
    const [selectedItem, setSeletctedItem] = useState<IAutomationObject>();
    const [css, theme] = useStyletron();
    const [moveObject, moveObjectResult] = useMoveObjectMutation();
    const intl = useIntl();

    const dmy = () => { };

    const onMove = () => {
        if (!selectedItem) return;
        moveObject({ objectId: appToMove.id, toObjectId: selectedItem.id, resourceGroupId: appToMove.resourceGroupId });
    }
    useEffect(() => {
        if (moveObjectResult?.isSuccess) {
            enqueue({
                actionMessage: intl.formatMessage({ id: "MoveAppDialog.GotoNewLocation", defaultMessage: "Goto new location" }),
                actionOnClick: () => navigate(GetObjectUrl(selectedItem?.resourceGroupId || '', selectedItem?.id || '')),
                message: intl.formatMessage({ id: "MoveAppDialog.SuccessMessage", defaultMessage: 'Sucessfully moved' }),
                startEnhancer: ({ size }) => <Check size={size} />,
            });
            setIsOpen(false);
        }
    }, [moveObjectResult]);

    const canMove = selectedItem && !moveObjectResult.isLoading && selectedItem?.id !== currentParent?.id;


    const filter = onFilter ?? handleFilter;
    return (

        <ModalAutoSize isOpen={isOpen} setIsOpen={setIsOpen}
            header={<FormattedMessage id="MoveAppDialog.Title" defaultMessage="Move App to"></FormattedMessage>}
            body={<ObjectsSelectView filter={filter} currentSelectedParent={currentParent} refetchCount={0} onSelectedItemChanged={(item) => setSeletctedItem(item)} showSystemApps={false} onParentChanged={dmy}></ObjectsSelectView>}
            footer={<>
                <ModalButton size='compact' kind={'tertiary'} onClick={() => setIsOpen(false)}><FormattedMessage id="cancel" defaultMessage="Cancel"></FormattedMessage> </ModalButton>
                <ModalButton size='compact' disabled={!canMove} onClick={onMove}><FormattedMessage id="MoveAppDialog.MoveButton" defaultMessage="Move here"></FormattedMessage></ModalButton>
            </>}
        ></ModalAutoSize>

    );

    function handleFilter(item: IAutomationObject) {
        return item.resourceGroupId === appToMove.resourceGroupId;
    }

}


export default MoveAppDialog;
